<template>
  <transition name="fade" :leave-active-class="'animated bounceOut'">
    <div class="integral-mask" style="z-index: 9999">
        <!-- {{duration}}{{score}} -->
      <!-- <transition-group :enter-active-class="'animated__animate__fadeInLeftBig'" :leave-active-class="'animated__positionanimate__fadeOutRightBig'"> -->
        <div class="animated zoomIn animate__faster " ref="bounce">
          <div class="lottie " :key="'animatedanimate'" >
            <div class="line">
              <img src="https://img.webloom.cn/img/scorePng1.png" alt="">
              <div class="text">
                <p class="t">
                  {{action}}
                </p>
                <p class="b">
                  {{scoreNum}}+{{score}}
                </p>
              </div>
            </div>
            <div class="coin">
              <img src="../../../assets/img/plaza/score/金币弹框.png" alt="">
                <div class="score">{{score}}</div>
            </div>
          </div>
        </div >
        
      <!-- </transition-group> -->
    </div>
  </transition>
</template>

<script type="text/javascript">

export default {
  name: 'IntegralMask',
  props: {
    // us: {}
    duration: {
      type: Number,
      default: 1000
    },
    score: {
      type: Number,
      required: true
    },
    action: {
      type: String,
      default: ''
    },
    scoreNum: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.closeMask()
  },
  methods: {
    closeMask () {
      const timmer = setTimeout(() => {
        this.$_IntegralMask.close()
      }, this.duration)
      this.$once('hook:beforeDestory', () => {
        clearTimeout(timmer)
      })
    }
  },
  created () {
    
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
@import 'animate.css';

.integral-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: rgba(0, 0, 0, .5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
  .animated {
    animation-duration: 1s;
    // margin-top: -100px;
    // transform: translateX(-50px);
  }
  // .animate .animate__bounce {
  //   --animate-duration: 2s;
  // }
  .lottie{
    height: 262px;
    width: 350px;
    position: relative;
    .line {
      position: relative;
      .text {
        position: absolute;
        left: 50%;
        bottom: 44px;
        transform: translateX(-50%);
        // background-color: rgba(240, 240, 247, .15);
        height: 65px;
        width: 100%;
        border-radius: 8px;
        text-align: center;
        color: #fff;
        .t {
          font-size: 18px;
          font-weight: 600;
          margin-top: 8px;
          margin-bottom: 0;
        }
        .b {
          font-size: 14px;
          margin-top: 4px;
        }
      }
    }
    
    .coin {
      position: absolute;
      height: 104px;
      width: 104px;
      top: 65px;
      left: 50%;
      transform: translateX(-50%);
      .score {
        height: 100%;
        width: 104px;
        line-height: 96px;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;
        font-size: 56px;
        font-family: NewMyFontScore;
        color: transparent;
        background: linear-gradient(to bottom, #FFFFFF, #FFD272);
        background-clip: text;
        -webkit-background-clip: text;
      }
    }
    img {
      width: 100%;
    }
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/IntegralMask/src/main.vue